import { render } from "./social-proof.vue?vue&type=template&id=2ce6cbf5"
import script from "./social-proof.vue?vue&type=script&lang=js"
export * from "./social-proof.vue?vue&type=script&lang=js"

import "./social-proof.vue?vue&type=style&index=0&id=2ce6cbf5&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__